import { config } from "../../../utils/config";
import { fetchDataAndMapToField } from "../../../utils/helperFuctions";

const useExtrasRatesLogic = () => {
  const apiRoute = "extrasrates";
  const onlyForm = undefined;

  const initFields = [
    {
      name: "addon",
      label: "Extra",
      type: "dropdown",
      isRequired: true,
      disableEditForNonAdmin: true,

      err: "Extra is required",
      returnID: true,
    },
    {
      name: "season",
      label: "Season",
      type: "dropdown",
      isRequired: true,
      disableEditForNonAdmin: true,
      err: "Season is required",
      returnID: true,
    },
    {
      name: "currency",
      label: "Currency",
      type: "dropdown",
      isRequired: false,
      disableEditForNonAdmin: true,
      err: "Currency is required",
      disabled: true,
      returnID: true,
      defaultsTo: "season.branch.currency.id",
      placeholder: "Season's branch currency",
    },
    {
      name: "mandatory",
      label: "Mandatory",
      type: "toggle",
      isRequired: false,
      disableEditForNonAdmin: true,
      err: "Mandatory is required",
    },
    {
      name: "is_fixed_rate",
      label: "Is fixed rate?",
      type: "toggle",
      isRequired: false,
      disableCondition: [
        {
          value: false,
          params: ["fixed_rate"],
          showparams: ["daily_rate", "weekly_rate", "monthly_rate"],
        },
        {
          value: true,
          params: ["daily_rate", "weekly_rate", "monthly_rate"],
          showparams: ["fixed_rate"],
        },
      ],
      err: "Is fixed rate is required",
    },
    {
      name: "fixed_rate",
      label: "Fixed rate",
      type: "number",
      minValue: 0,
      isRequired: false,
      err: "Fixed rate is required",
    },
    {
      name: "daily_rate",
      label: "Daily rate",
      type: "number",
      minValue: 0,
      isRequired: true,
      err: "Daily rate is required",
    },
    {
      name: "weekly_rate",
      label: "Weekly rate",
      type: "number",
      minValue: 0,
      isRequired: true,
      err: "Weekly rate is required",
    },
    {
      name: "monthly_rate",
      label: "Monthly rate",
      type: "number",
      minValue: 0,
      isRequired: true,
      err: "Monthly rate is required",
    },
    // Add more fields as needed
  ];

  //Roles
  const admin = process.env.REACT_APP_ADMIN_ROLE;
  const financeRole = process.env.REACT_APP_FINANCE_ROLE;
  const managerRole = process.env.REACT_APP_MANAGER_ROLE;
  ///Add,Delete,Edit Roles
  const addRoles = [admin, financeRole, managerRole];
  const deleteRoles = [admin, financeRole, managerRole];
  const editRoles = [admin, financeRole, managerRole];

  const getPromises = (temp) => {
    return [
      fetchDataAndMapToField(
        config,
        "seasons",
        "season",
        temp,
        "Name",
        "branch"
      ),
      fetchDataAndMapToField(config, "addons", "addon", temp),
      fetchDataAndMapToField(
        config,
        "currencies",
        "currency",
        temp,
        "code",
        "symbol"
      ),
    ];
  };
  return {
    apiRoute,
    onlyForm,
    initFields,
    addRoles,
    deleteRoles,
    editRoles,
    getPromises,
  };
};

export default useExtrasRatesLogic;
